import React, { useState } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/navbar/Navbar.js';
import Banner from '../components/Banner.js';
import pumpe from '../images/pumpe/banner.png';
import pumpeBg from '../images/pumpe/pic1.jpg';
import pumpeVideo from '../images/pumpe/v500.mp4';
import kiVideo from '../images/pumpe/ki.mp4';
import diagramm from '../images/pumpe/diagramm.png';
import { useSEO } from '../components/CustomHook';
import Modal from '../components/Modal.js';

const Waermepumpe = () => {
    useSEO(
        "Wärmepumpe - Effiziente Wärme aus der Umwelt | Schmid Energieberatung",
        "Entdecken Sie unsere hochwertigen Wärmepumpen für Ihr Zuhause. Effiziente Heizung mit geringem Stromverbrauch und maximaler Umweltfreundlichkeit.",
        "Wärmepumpe, Wärmepumpen, Heizung, Umweltwärme, Energieeffizienz, Klimaschutz",
        "/images/products/waermepumpe.webp"
    );

    // Add state for modal
    const [modalData, setModalData] = useState({ isOpen: false, title: '', content: [] });

    // Function to close modal
    const closeModal = () => {
        setModalData({ isOpen: false, title: '', content: [] });
    };

    // Function to open modal with specific content
    const openFoerderungModal = () => {
        setModalData({
            isOpen: true,
            title: 'Förderung für Ihre neue Heizung',
            content: [
                 <>
                 Der Wechsel zu einer <strong>Wärmepumpe</strong> ist jetzt besonders attraktiv: Der Staat fördert den Umstieg mit <strong>bis zu 70 % Zuschuss</strong> – ideal für Eigentümer von Bestandsgebäuden. Nutzen Sie diese Chance, bevor die Fördermittel gekürzt werden!
                 </>,
                <><strong>Ihre Fördermöglichkeiten im Überblick:</strong></>,
                <>
                    • <strong>30 % Basisförderung</strong> – für alle Panasonic Wärmepumpen, z.B. die beliebte Panasonic Aquarea T-CAP.
                </>,
                <>
                    • <strong>20 % Klimageschwindigkeitsbonus</strong> – beim Austausch funktionierender Öl-, Kohle-, Gasetagen- oder Nachtspeicherheizungen jeden Alters oder Gas-/Biomasseheizungen, die älter als 20 Jahre sind (befristet bis 2028).
                </>,
                <>
                    • <strong>30 % Einkommensbonus</strong> – für selbstnutzende Eigentümer mit einem zu versteuernden Haushaltseinkommen bis 40.000 € jährlich.
                </>,
                <>
                    • <strong>5 % Effizienzbonus</strong> – wenn als Wärmequelle Wasser, Erdreich oder Abwasser genutzt wird oder ein natürliches Kältemittel zum Einsatz kommt.
                </>,
                <>
                    Alle Boni sind mit der Basisförderung kombinierbar – so können Sie <strong>bis zu 70 % der förderfähigen Investitionskosten </strong> (max. 30.000 € für die erste Wohneinheit) erhalten.
                </>,
                <><strong>Warum Panasonic?</strong></>,
                <>
                    • Hohe Effizienz auch bei sehr niedrigen Außentemperaturen T-Cap Technologie
                </>,
                <>
                    • Leiser Betrieb und langlebige Technik
                </>,
                <>
                    • Perfekt kombinierbar mit Photovoltaikanlagen – maximale Autarkie möglich
                </>,
                <>
                <strong>Tipp</strong>: Mit unserem <a href="/foerderrechner-waermepumpe" className="text-primary hover:underline"><strong>Förderrechner</strong></a> finden Sie in wenigen Sekunden heraus, wie viel Förderung Sie genau für Ihre neue Panasonic Wärmepumpe erhalten können.
                </>,
                 <>
                    <strong>Jetzt ist der richtige Zeitpunkt</strong>: Setzen Sie auf bewährte Panasonic Qualität, sparen Sie langfristig Energiekosten und sichern Sie sich die maximale Förderung. Wir begleiten Sie bei der Umsetzung Ihres Projekts.
                </>,
            ]
        });
    };

    return (
        <>
            <Navbar />
            <Banner
                imageSrc={pumpe}
                title="Wärmepumpe"
                subtitle="Effiziente Wärme aus der Umwelt"
                description="Moderne Wärmepumpen nutzen erneuerbare Energie aus Luft, Wasser oder Erdreich für eine umweltfreundliche und kostengünstige Heizung."
                imagePosition="right"
            />

            {/* Text under Banner */}
            <div className="w-full max-w-7xl mx-auto py-10 px-6">
                <div className="bg-secondary-light rounded-xl p-8 text-center">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                        Die Wärmepumpe im System der Schmid Energieberatung GmbH
                    </h2>
                    <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        In Kombination mit Ihrer Photovoltaikanlage sorgt die Wärmepumpe von Schmid
                        Energieberatung GmbH für eine besonders effiziente und nachhaltige Heizlösung.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        Unser intelligentes Energiemanagementsystem erkennt automatisch, wann Ihre Wärmepumpe
                        mit selbsterzeugtem Solarstrom betrieben werden kann – oder bei Bedarf auf günstigen
                        Netzstrom umschaltet. So sparen Sie bis zu 50 % Heizkosten und steigern gleichzeitig Ihre
                        Unabhängigkeit von Energieversorgern.
                    </p>
                    <p className="text-xl font-semibold text-primary">
                        Effizient, smart und klimafreundlich – Ihre Wärmeversorgung mit System.
                    </p>
                    <div className="mt-8">
                        <a
                            href="/kontakt"
                            className="bg-primary text-white rounded-lg font-semibold text-lg px-8 py-4 transition-all duration-200 hover:scale-105 inline-block"
                        >
                            Jetzt beraten lassen!
                        </a>
                    </div>
                </div>
            </div>

            {/* Grid Section */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 grid-rows-2 gap-8">
                    {/* Box 1: 1st row, 1st column */}
                    <div className="bg-gray-100 rounded-xl flex flex-col items-center justify-center p-6">
                        <p className="text-2xl font-semibold text-center mb-4">
                            Bis zu 70% Zuschuss
                            <br />
                            Über die KFW
                        </p>
                        <a
                            href="/foerderrechner-waermepumpe"
                            className="bg-primary text-white rounded-lg font-semibold text-base px-6 py-3 transition-all duration-200 hover:scale-105"
                        >
                            mehr erfahren
                        </a>
                    </div>

                    {/* Box 2: 1st row, 2nd & 3rd columns */}
                    <div className="bg-gray-100 rounded-xl flex items-center justify-center p-6 md:col-span-2 md:col-start-2 relative overflow-hidden">
                        <div className="absolute inset-0 bg-center" style={{ backgroundImage: `url(${pumpeBg})`, backgroundSize: '100% auto' }}></div>
                        <p className="text-2xl font-semibold text-center relative z-10 px-4 text-white">
                            Die Kraft der Sonne für Ihr
                            <br />
                            Zuhause: bis zu 70 %
                            <br />
                            Heizenergie aus Eigenstrom
                        </p>
                    </div>

                    {/* Box 3: 1st & 2nd rows, 4th column */}
                    <div className="bg-gray-100 rounded-xl flex items-center justify-center p-6 md:row-span-2 md:col-start-4">
                        <p className="text-2xl font-semibold text-center">
                            0 Cent pro kWh –
                            <br />
                            wenn Sie Ihren
                            <br />
                            Solarstrom clever
                            <br />
                            nutzen
                        </p>
                    </div>

                    {/* Box 4: 2nd row, 1st, 2nd & 3rd columns */}
                    <div className="bg-gray-100 rounded-xl flex items-center justify-center p-6 md:col-span-3 md:row-start-2">
                        <p className="text-2xl font-semibold text-center">
                            umweltbewusst und langfristig stabil
                        </p>
                    </div>
                </div>
            </div>

            {/* Text under Grid */}
            <div className="w-full max-w-7xl mx-auto py-10 px-6">
                <div className="bg-secondary-light rounded-xl p-8 text-center">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                        Alles smart vernetzt – Ihre Komplettlösung von Schmid-Energieberatung GmbH
                    </h2>
                    <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        Bei uns erhalten Sie weit mehr als nur eine Wärmepumpe. Wir bieten Ihnen ein ganzheitliches
                        Energiesystem, das perfekt aufeinander abgestimmt ist: Photovoltaikanlage, leistungsstarker
                        Stromspeicher, moderne Wärmepumpe sowie intelligente Steuerung und Energiemanagement
                        – alles aus einer Hand und professionell umgesetzt.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed mb-6">
                        Unsere smarte Steuerung sorgt dafür, dass alle Komponenten nahtlos zusammenarbeiten: Ihre
                        Wärmepumpe nutzt bevorzugt selbst erzeugten Solarstrom, überschüssige Energie wird
                        automatisch im Speicher abgelegt und kann bei Bedarf effizient genutzt werden. So steigern
                        Sie Ihre Unabhängigkeit vom Energieversorger, senken nachhaltig Ihre Kosten und erhöhen
                        gleichzeitig den Komfort in Ihrem Zuhause.
                    </p>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        Mit Schmid-Energieberatung GmbH setzen Sie auf ein regionales Meisterunternehmen, das
                        nicht nur die Technik liefert, sondern auch die individuelle Beratung, Planung und Umsetzung
                        übernimmt. Unser Ziel ist es, Ihnen maximale Energieeinsparung, größtmögliche Autarkie
                        und langfristige Sicherheit zu bieten – intelligent vernetzt, zukunftssicher und
                        maßgeschneidert auf Ihre Bedürfnisse.
                    </p>
                </div>
            </div>

            {/* Video Section */}
            <div className="w-full max-w-7xl mx-auto py-10 px-6">
                <div className="rounded-xl overflow-hidden">
                    <video className="w-full h-auto"
                    autoPlay
                    loop
                    muted
                    playsInline
                    >
                        <source src={pumpeVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>

            {/* Text with Video Section */}
            <div className="w-full max-w-7xl mx-auto py-10 px-6">
                <div className="p-8 flex flex-col md:flex-row gap-8 items-center">
                    <div className="md:w-1/2">
                        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                            Maximale Ersparnis mit dem Sigen KI-Modus
                        </h2>
                        <p className="text-lg text-gray-700 leading-relaxed mb-4">
                            <strong>Bis zu 50 % weniger Heizkosten dank intelligenter
                            Wärmepumpe und Stromspeicher</strong>
                        </p>
                        <p className="text-lg text-gray-700 leading-relaxed mb-4">
                            Mit der <strong>Sigen-KI</strong> nutzen Sie Ihre selbst erzeugte Solarenergie
                            optimal – und reduzieren Ihre Heizkosten auf ein Minimum.
                            Möglich macht das die Kombination aus einer <strong>effizienten
                            Wärmepumpe</strong>, dem <strong>intelligenten SigenStore</strong> und unserem
                            durchdachten Energiemanagement.
                        </p>
                        <p className="text-lg text-gray-700 leading-relaxed mb-4">
                            Die Wärmepumpe wird vorrangig mit <strong>kostenlosem PV-
                            Überschussstrom</strong>betrieben. Fehlt direkte Sonneneinstrahlung,
                            greift das System automatisch auf den gespeicherten Solarstrom
                            zurück – und nutzt nur dann Netzstrom, wenn er <strong>besonders
                            günstig</strong> verfügbar ist.
                        </p>
                        <p className="text-lg text-gray-700 leading-relaxed">
                            Das Ergebnis: <strong>Maximale Unabhängigkeit</strong>, deutlich geringere
                            Energiekosten und ein <strong>nachhaltiger Beitrag zum Klimaschutz </strong>
                            – ganz ohne Komfortverlust.
                        </p>
                    </div>
                    <div className="md:w-1/2 rounded-xl overflow-hidden">
                        <video className="w-full h-auto"
                        autoPlay
                        loop
                        muted
                        playsInline
                        >
                            <source src={kiVideo} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            </div>

            {/* Diagram Image */}
            <div className="w-full max-w-7xl mx-auto py-10 px-6">
                <div className="rounded-xl overflow-hidden">
                    <img src={diagramm} alt="Wärmepumpe Diagramm" className="w-full h-auto" />
                </div>
            </div>

            {/* Förderung Box */}
            <div className="w-full max-w-7xl mx-auto py-10 px-6">
                <div className="bg-secondary-light rounded-xl p-8 text-center">
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                        Bis zu 70% Förderung für Ihre neue Heizung
                    </h2>
                    <p className="text-lg text-gray-700 leading-relaxed mb-8">
                        Der Wechsel zu einer Wärmepumpe ist jetzt besonders attraktiv: Der Staat fördert den
                        Umstieg mit bis zu <strong>70 % Zuschuss</strong> – ideal für Eigentümer von Bestandsgebäuden. Nutzen
                        Sie diese Chance, bevor die Fördermittel gekürzt werden!
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="/foerderrechner-waermepumpe"
                            className="bg-primary text-white rounded-lg font-semibold text-lg px-8 py-4 transition-all duration-200 hover:scale-105 inline-block text-center"
                        >
                            Förderrechner
                        </a>
                        <button
                            onClick={openFoerderungModal}
                            className="bg-gray-200 text-gray-800 rounded-lg font-semibold text-lg px-8 py-4 transition-all duration-200 hover:scale-105 inline-block"
                        >
                            mehr erfahren
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal for Förderung details */}
            <Modal isOpen={modalData.isOpen} onClose={closeModal} title={modalData.title} content={modalData.content} />

            {/* Additional Text Section */}
            <div className="w-full max-w-7xl mx-auto py-10 px-6">
                <h2 className="text-2xl md:text-3xl font-bold text-primary mb-6">
                    Die modernste und effizienteste Art zu heizen
                </h2>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    Wärmepumpen machen sich die natürliche Energie zunutze, die uns in der Umwelt kostenlos
                    zur Verfügung steht – in der Luft, im Erdreich oder im Wasser. Mithilfe eines effizienten
                    Kältemittelkreislaufs wird diese gespeicherte Energie aufgenommen und in wohlige Wärme
                    für Ihr Zuhause umgewandelt.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    Der große Vorteil: Sie benötigen keine fossilen Brennstoffe mehr. Die Wärmepumpe arbeitet
                    nahezu unabhängig von Energiepreisschwankungen und erzeugt ein Vielfaches der
                    eingesetzten elektrischen Energie als Heizwärme – das macht sie zu einer der effizientesten
                    Heiztechnologien überhaupt.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    Noch besser wird das System, wenn Sie es mit <strong>eigenem Solarstrom</strong> betreiben:
                </p>
                <ul className="text-lg text-gray-700 leading-relaxed mb-4">
                    <li className="mb-2">• <strong>Maximale Effizienz</strong>: Ihre Wärmepumpe nutzt den selbst erzeugten Strom Ihrer Photovoltaikanlage.</li>
                    <li className="mb-2">• <strong>Emissionsfrei</strong>: In Kombination mit Solarstrom heizen Sie komplett CO₂-neutral.</li>
                    <li className="mb-2">• <strong>Rund um die Uhr unabhängig</strong>: Mit einem Stromspeicher steht Ihnen die Energie auch nachts oder in den kalten Wintermonaten zur Verfügung.</li>
                </ul>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    So machen Sie sich von fossilen Brennstoffen unabhängig, senken Ihre Energiekosten
                    langfristig und leisten gleichzeitig einen wichtigen Beitrag zum Klimaschutz.
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-4">
                    <strong>Die passende Wärmepumpe zu finden, ist entscheidend für Effizienz, Komfort und
                    Langlebigkeit</strong>. Genau hier setzen wir an:
                </p>
                <p className="text-lg text-gray-700 leading-relaxed mb-6">
                    Wir beraten Sie persönlich und analysieren Ihre Wohnsituation, den Energiebedarf sowie die
                    baulichen Voraussetzungen. So finden wir gemeinsam die Wärmepumpe, die perfekt zu Ihrem
                    Zuhause passt – und Sie langfristig zuverlässig und sparsam mit Wärme versorgt.
                </p>
                <div className="mt-8">
                    <a
                        href="/kontakt"
                        className="bg-primary text-white rounded-lg font-semibold text-lg px-8 py-4 transition-all duration-200 hover:scale-105 inline-block"
                    >
                        Jetzt beraten lassen!
                    </a>
                </div>
            </div>

            <Footer />
        </>
    );
};

export default Waermepumpe;